import React, { useRef, useEffect } from 'react';
import TKAlert from '@xo-union/tk-component-alerts';

export const DEFAULT_MESSAGE = 'Something went wrong! Please try again later.';
const ERROR_TIMEOUT = 4000;

interface Props {
  erroring: boolean;
  errorMessage?: string | null;
  onTimeout: () => void;
}

interface AlertProps {
  type: string;
  content: string;
}

interface AlertRef {
  show: (props: AlertProps) => void;
  dismiss: () => void;
}

const Alert: React.FC<Props> = ({ erroring, errorMessage, onTimeout }) => {
  const alert = useRef<AlertRef>();

  useEffect(() => {
    if (erroring) {
      alert.current?.show({
        type: 'error',
        content: errorMessage || DEFAULT_MESSAGE,
      });
      const timeoutId = setTimeout(onTimeout, ERROR_TIMEOUT);
      return () => clearTimeout(timeoutId);
    } else {
      alert.current?.dismiss();
    }
  }, [erroring, alert, errorMessage, onTimeout]);

  return <TKAlert ref={alert} position="bottom" />;
};

export default Alert;
